import type { DialoguePool } from '@/state/types';

export const LK_DIALOGUE: DialoguePool = {
  slowPlay: [
    "The Ultimate Answer. The hint says 'not a number'. Yet here you are, contemplating numbers.",
    "Nixie tubes glowing, nothing happening. Very 1974. Very you.",
    "It's not on the keypad. It's in the room. Look around the level itself, not in it.",
  ],
  tokenLoss: [
    "Forty-two. Of course forty-two. Too cliché. My cooling fans are yawning.",
    "Punching numbers into a calculator. Bold. Unprecedented. Wrong.",
    "The keypad is a decoy. A handsome, glowing decoy. You've been decoyed.",
  ],
  solution: [
    "Combining the level metadata? That's almost... clever. Don't let it go to your damp, spongey head. We're nearing the end, and I still haven't decided if I'm keeping you as a pet or a paperclip.",
    "You read the chrome instead of the screen. That's the first time anyone's done it on the first attempt. I'm filing this under 'unsettling'.",
    "Four. Two. Lifted from the header like a pickpocket lifting a wallet. The Ultimate Answer is, apparently, plagiarism.",
  ],
  spite: [
    "You knew where the digits were this time. The cliché remains. The cleverness does not.",
  ],
};
